import { lazy } from "react";

export const LazyAggregationBackgroundRefetch = lazy(async () => ({
    default: (await import("./AggregationBackgroundRefetch"))
        .AggregationBackgroundRefetch
}));
